import createIntersectionObserver from "../../utils/createIntersectionObserver";
import getDFPBlock from "../../utils/getDFPBlock";
import destroyCatfish from "../../destroyAdvBlocks/destroyCatfish";
import styleCatfish from "../../utils/styleCatfish";

export default function (){
    if(document.getElementById('newsAnnotation') === null){
        return;
    }

    if(window.innerWidth < 1000){
        return;
    }

    createIntersectionObserver('#newsAnnotation', renderCatFish);

    function renderCatFish() {
        destroyCatfish();
        let mobileCatfishPlace = document.getElementById('mobile-banner-zone');
        if (mobileCatfishPlace !== null) {
            let catfishId = 'catfish-desktop-' + Math.round(Math.random() * 1000000);
            let catfishWrapper = document.createElement('div');
            catfishWrapper.id = catfishId;
            mobileCatfishPlace.appendChild(catfishWrapper);

            let computeDesktopCatfish = styleCatfish('mobile-banner-zone', 970);
            getDFPBlock('/56301415/finance24_catfish', [[970, 90], [1, 1]], catfishId, '970px', computeDesktopCatfish, undefined);
        }
    }
}